import React, { ReactNode } from 'react'
import { Stack, Tooltip, IconButton } from '@mui/material'
import { Check, Science } from '@mui/icons-material'
import { IsinEntity, IssueListByCompanyItem, WarrantListItem } from '@finance-lab/utils/types'

export const CompanyEventRow = <
    E extends 'issue' | 'warrant',
    T extends E extends 'issue' ? IssueListByCompanyItem : WarrantListItem,
>({
    event,
    eventType,
    selectedIsin,
    setSelectedIsin,
    addIsinToEntity,
    onArchiveIsin,
    children,
}: {
    children: ReactNode
    event: T
    eventType: E
    selectedIsin: IsinEntity | null
    setSelectedIsin: (i: IsinEntity | null) => void
    addIsinToEntity: (e: { id: string }, isin: IsinEntity) => Promise<void>
    onArchiveIsin: (i: IsinEntity, archive?: boolean) => Promise<void>
}) => {
    const onAssociate = async () => {
        if (!addIsinToEntity) {
            throw new Error('addIsinToIssue not implemented')
        }
        if (!selectedIsin) {
            console.log('ERROR: No selected Isin')
            throw new Error('No selected Isin')
        }

        await addIsinToEntity(event, selectedIsin)

        if (onArchiveIsin) onArchiveIsin(selectedIsin, false)
        setSelectedIsin(null)
    }

    const isEventCompleted = Boolean(event?.statusStage === 10 && event?.statusComplete)

    return (
        <tr>
            <td>
                <Stack spacing={2} key={event.id} sx={{ mb: 6 }}>
                    <Stack
                        direction='row'
                        spacing={2}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Tooltip title={`Koppla ISIN till ${eventType === 'issue' ? 'emission' : 'option'}`}>
                            <IconButton
                                sx={{
                                    width: 30, // Adjust the width for your desired size
                                    height: 30, // Adjust the height for your desired size
                                    borderRadius: '50%', // Makes the button round
                                    backgroundColor: isEventCompleted ? 'success.main' : 'primary.main', // Optional: Set a background color for better visibility
                                    border: '2px solid', // Adds a border
                                    borderColor: isEventCompleted ? 'success.main' : 'primary.main', // Set border color with main variant
                                    color: 'white', // Set icon color for better contrast
                                    '&:hover': {
                                        backgroundColor: isEventCompleted ? 'success.dark' : 'primary.dark', // Darker color on hover
                                        borderColor: isEventCompleted ? 'success.dark' : 'primary.dark', // Darker border color on hover
                                    },
                                }}
                                onClick={() => onAssociate()}
                            >
                                {isEventCompleted && <Check sx={{ fontSize: 22 }} />}
                                {!isEventCompleted && <Science sx={{ fontSize: 22 }} />}
                            </IconButton>
                        </Tooltip>
                        <>{children}</>
                    </Stack>
                </Stack>
            </td>
        </tr>
    )
}
